import cx from 'classnames';
import { Line } from '@visx/shape';
import { Group } from '@visx/group';
import { Text } from '@visx/text';
import Orientation from "../constants/orientation.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Ticks(_ref) {
  let {
    hideTicks,
    horizontal,
    orientation,
    tickClassName,
    tickComponent,
    tickLabelProps: allTickLabelProps,
    tickStroke = '#222',
    tickTransform,
    ticks,
    strokeWidth,
    tickLineProps
  } = _ref;
  return ticks.map(_ref2 => {
    let {
      value,
      index,
      from,
      to,
      formattedValue
    } = _ref2;
    const tickLabelProps = allTickLabelProps[index] ?? {};
    const tickLabelFontSize = Math.max(10, typeof tickLabelProps.fontSize === 'number' && tickLabelProps.fontSize || 0);
    const tickYCoord = to.y + (horizontal && orientation !== Orientation.top ? tickLabelFontSize : 0);
    return /*#__PURE__*/_jsxs(Group, {
      className: cx('visx-axis-tick', tickClassName),
      transform: tickTransform,
      children: [!hideTicks && /*#__PURE__*/_jsx(Line, {
        from: from,
        to: to,
        stroke: tickStroke,
        strokeWidth: strokeWidth,
        strokeLinecap: "square",
        ...tickLineProps
      }), tickComponent ? tickComponent({
        ...tickLabelProps,
        x: to.x,
        y: tickYCoord,
        formattedValue
      }) : /*#__PURE__*/_jsx(Text, {
        x: to.x,
        y: tickYCoord,
        ...tickLabelProps,
        children: formattedValue
      })]
    }, `visx-tick-${value}-${index}`);
  });
}